// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"110":"0de65e26","749":"0de65e26","824":"1b8c82d6"}[chunkId] + ".chunk.css";
};